// Resolve URLs to the runtime service.
//
// In dev, the runtime is reached via the Vite proxy (/ws, /audio, /last-prompt
// → localhost:3008). In production, the runtime lives on its own subdomain
// (e.g. agentruntime-dev.smartslot.ai), so we point at it directly.
//
// VITE_RUNTIME_HOST is set in admin/client/.env.production. When unset
// (dev), URLs fall back to window.location.host so the Vite proxy handles them.

const RUNTIME_HOST = import.meta.env.VITE_RUNTIME_HOST || (
  typeof window !== "undefined" ? window.location.host : "localhost"
);

const isHttps = typeof window !== "undefined" && window.location.protocol === "https:";
const HTTP_PROTO = isHttps ? "https:" : "http:";
const WS_PROTO = isHttps ? "wss:" : "ws:";

export function runtimeWsUrl(path = "/ws") {
  return `${WS_PROTO}//${RUNTIME_HOST}${path}`;
}

export function runtimeHttpUrl(path) {
  return `${HTTP_PROTO}//${RUNTIME_HOST}${path}`;
}
